var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgChatLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8068_14822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.636 21.1602H24.6377V6.82991H5.53065V22.8141L7.636 21.1602ZM8.46238 23.5485L3.14227 27.7282V5.63572C3.14227 5.319 3.26809 5.01525 3.49204 4.7913C3.716 4.56734 4.01974 4.44153 4.33646 4.44153H25.8319C26.1486 4.44153 26.4523 4.56734 26.6763 4.7913C26.9002 5.01525 27.026 5.319 27.026 5.63572V22.3544C27.026 22.6711 26.9002 22.9748 26.6763 23.1988C26.4523 23.4227 26.1486 23.5485 25.8319 23.5485H8.46238Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8068_14822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6605,
    height: 28.6605,
    transform: "translate(0.753906 0.859009)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgChatLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chat-line.83eea4bb663a0d1716d6e90a230459c5.svg";